// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let SettingsPageHeader = require("./SettingsPageHeader.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let SharingProfileMiniFormProfilePhoto = require("../../reason/settings/components/avatarField/SharingProfileMiniFormProfilePhoto.bs.js");
let ProfilePageProfilePhotoForm_agent_graphql = require("../../__generated__/ProfilePageProfilePhotoForm_agent_graphql.bs.js");

let convertFragment = ProfilePageProfilePhotoForm_agent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ProfilePageProfilePhotoForm_agent_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ProfilePageProfilePhotoForm_agent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ProfilePageProfilePhotoForm_agent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ProfilePageProfilePhotoForm_agent_graphql.node, convertFragment, fRef);
}

let AgentFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ProfilePageProfilePhotoForm(props) {
  let agent = RescriptRelay_Fragment.useFragment(ProfilePageProfilePhotoForm_agent_graphql.node, convertFragment, props.agent);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(SettingsPageHeader.SectionHeading.make, {
        title: "Change your profile photo"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("p", {
            children: "Upload a photo to show on your Top Agent Network profile.",
            className: ""
          }),
          JsxRuntime.jsx(SharingProfileMiniFormProfilePhoto.make, {
            agent: agent.fragmentRefs
          })
        ],
        className: ""
      })
    ],
    className: "flex flex-col space-y-4"
  });
}

let make = ProfilePageProfilePhotoForm;

exports.AgentFragment = AgentFragment;
exports.make = make;
/* react/jsx-runtime Not a pure module */
